import createInformesSectionPage from "./SectionPageFactory";

const InformesTesoreriaDepositosPage = createInformesSectionPage(
  "Tesorería · Depósitos y bancos",
  "Seguimiento de boletas declaradas, acreditaciones bancarias y conciliaciones de tesorería."
);

export default InformesTesoreriaDepositosPage;
